import React from "react";
import PT from "prop-types";
import { Button } from "_c/button";
import { useDispatch } from "react-redux";
import { Actions as ModalActions } from "@/store/modals/slice";
import { useAsyncCallback } from "@/hooks/useAsyncCallback";
import { useNotify } from "@/hooks/useNotify";
import { ExtMessengerAPI } from "@/api/extMessenger";
import { Translate } from "@/i18n/utils";
import Tmpl from "_c/MessengerSubTmpl";
import { analyticsAction } from "@/utils/analytics";

const MessengerRow = ({ ns, ...props }) => {
  const { notify, notifyError } = useNotify();
  const [unsub, isUnsubbing] = useAsyncCallback({
    callback: () => ExtMessengerAPI.unsub(props.token, props.messenger),
    onSuccess: ({ data }) => {
      analyticsAction({
        category: "messengers",
        action: `${props.messenger}_client_unsub_click`,
      });
      notify(props.t(`${ns}.unsub_success`));
      props.updateData(data);
    },
    onError: (e) => notifyError(Translate.serverError(props.t, e)),
  });
  const dispatch = useDispatch();
  const onSubscribeClick = () => {
    analyticsAction({
      category: "messengers",
      action: `${props.messenger}_client_sub_click`,
    });
    dispatch(ModalActions.openShare(props.link));
  };
  return (
    <Tmpl
      icon={props.icon}
      isActive={props.isActive}
      activeStatusText={props.t(`${ns}.sub_active`)}
      inactiveStatusText={props.t(`${ns}.sub_inactive`)}
      SubButton={
        <Button onClick={onSubscribeClick} small greenish>
          {props.t(`${ns}.sub_btn`)}
        </Button>
      }
      UnsubButton={
        <Button onClick={unsub} small disabled={isUnsubbing} negative>
          {props.t(`${ns}.unsub_btn`)}
        </Button>
      }
    />
  );
};
MessengerRow.propTypes = {
  icon: PT.string.isRequired,
  isActive: PT.bool,
  link: PT.string.isRequired,
  messenger: PT.string.isRequired,
  token: PT.string.isRequired,
  ns: PT.string.isRequired,

  updateData: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default MessengerRow;
